import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid2, IconButton, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Typography } from '@mui/material';
import React, { useEffect, useRef } from 'react';
import { BudgetItemsTemplateRycApiClient, BudgetItemTemplateDto, PartnerDto, PartnersRycApiClient } from '../../Api/ApiServer';
import { Inbox, Drafts, Business, Delete, Edit, ArrowBack, Save, Add, Category } from '@mui/icons-material';
import DeleteDialog from '../../Shared/DeleteDialog';
import { useApi } from '../../Api/useApi';
import BudgetItemDetail, { BudgetItemDetailRef } from './BudgetItemDetail';

export interface BudgetItemsDetailDialogProps {
    onClose: () => void;
    open: boolean;
    onSelect: (budgetItem: BudgetItemTemplateDto) => void;
    externalSelectedItemCode?: string;
    onlyView?: boolean;
}
export default function BudgetItemsDetailDialog(props: BudgetItemsDetailDialogProps, ref: any) {
    const { onClose, open, onSelect, externalSelectedItemCode, onlyView } = props;
    const [deletingBudgetItem, setDeletingBudgetItem] = React.useState<BudgetItemTemplateDto | null>(null);
    const [selectedBudgetItem, setSelectedBudgetItem] = React.useState<BudgetItemTemplateDto | null>(null);

    const [budgetItems, setBudgetItems] = React.useState<BudgetItemTemplateDto[]>([]);

    const { authorizedApi } = useApi(BudgetItemsTemplateRycApiClient);

    useEffect(() => {
        if (open) {
            setSelectedBudgetItem(null);
            loadBudgetItems();
        }
    }, [open]);

    const loadBudgetItems = async () => {
        const response = await authorizedApi?.getBudgetItemsTemplates();
        if (response) {
            setBudgetItems(response?.budgetItems ?? []);
        }
    };
    useEffect(() => {
        if (externalSelectedItemCode && budgetItems.length > 0)
            setSelectedBudgetItem(budgetItems.find(bi => bi.code === externalSelectedItemCode) ?? null);
    }, [externalSelectedItemCode, budgetItems])

    // const [open, setOpen] = React.useState(false);
    const handleClose = () => {
        onClose();
    };

    const budgetItemDetailRef = useRef<BudgetItemDetailRef>(null);

    return (
        <Dialog
            open={open}
            fullWidth
            onClose={() => { handleClose() }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                {selectedBudgetItem === null && <Grid2 size={{ xs: 12 }} display={'flex'} alignItems={'center'}>
                    <Typography variant="h5" gutterBottom sx={{ flexGrow: 1, mt: 1 }}>
                        {'Seznam položek rozpočtu'}
                    </Typography>
                    <IconButton onClick={() => setSelectedBudgetItem(new BudgetItemTemplateDto())}>
                        <Add />
                    </IconButton>
                </Grid2>}
                {selectedBudgetItem !== null && !onlyView && <Grid2 size={{ xs: 12 }} display={'flex'} alignItems={'center'}>
                    <IconButton onClick={() => setSelectedBudgetItem(null)}>
                        <ArrowBack />
                    </IconButton>
                    <Typography variant="h5" gutterBottom sx={{ flexGrow: 1, mt: 1 }}>
                        {'Detail položky rozpočtu'}
                    </Typography>
                    <IconButton onClick={() => budgetItemDetailRef.current?.onSaveBudgetItem()}>
                        <Save />
                    </IconButton>
                </Grid2>}
                {selectedBudgetItem !== null && onlyView && <Grid2 size={{ xs: 12 }} display={'flex'} alignItems={'center'}>
                 
                    <Typography variant="h5" gutterBottom sx={{ flexGrow: 1, mt: 1 }}>
                        {'Detail položky rozpočtu'}
                    </Typography>
                </Grid2>}
            </DialogTitle>
            <DialogContent dividers sx={{ maxHeight: "60vh", overflowY: "auto", display: "flex", flexDirection: "column" }}>
                {selectedBudgetItem === null && <List>
                    {budgetItems.map((budgetItem, index) => (
                        <ListItem key={index} component="div" sx={{ cursor: "pointer" }} onClick={() => onSelect(budgetItem)}>
                            <ListItemIcon sx={{ flexShrink: 0 }}>
                                <Category />
                            </ListItemIcon>
                            <ListItemText primary={budgetItem.code} sx={{ flex: 1 }} />
                            <ListItemText primary={budgetItem.description} />
                            <IconButton onClick={(e) => { e.preventDefault(); e.stopPropagation(); setSelectedBudgetItem(budgetItem); }} sx={{ flexShrink: 0, minWidth: "auto", padding: 0 }}>
                                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", width: 40, height: 40 }}>
                                    <Edit />
                                </Box>
                            </IconButton>
                            <IconButton onClick={(e) => { e.preventDefault(); e.stopPropagation(); setDeletingBudgetItem(budgetItem) }} sx={{ flexShrink: 0, minWidth: "auto", padding: 0 }}>
                                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", width: 40, height: 40 }}>
                                    <Delete />
                                </Box>
                            </IconButton>
                        </ListItem>
                    ))}
                </List>}
                {selectedBudgetItem !== null && <BudgetItemDetail ref={budgetItemDetailRef} budgetItem={selectedBudgetItem} onSaved={() => { setSelectedBudgetItem(null); loadBudgetItems(); }} />}
                <DeleteDialog open={deletingBudgetItem !== null} data={deletingBudgetItem} onClose={() => { setDeletingBudgetItem(null) }} onDeleteAgree={(data) => {
                    setDeletingBudgetItem(null);
                    authorizedApi?.deleteBudgetItemTemplate(data.id).then(() => {
                        loadBudgetItems();
                    })
                }} />
            </DialogContent>
            <DialogActions>
                {/* <Button onClick={() => { handleClose() }} autoFocus>
                    {'OK'}
                </Button> */}
                <Button onClick={() => { handleClose() }} autoFocus>
                    {'ZAVŘÍT'}
                </Button>
            </DialogActions>
        </Dialog>);
}